import { useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../../helpers/httpWrapper';
import {
	IProvisionOneSignalAppReq,
	IProvisionOneSignalAppRes,
	VProvisionOneSignalApp,
} from '../../../../../networked-shared-interfaces/platform-admin/onesignal-route';
import { URLWrapper } from '../../../../../networked-shared-interfaces/url-wrapper';
import { toastService } from '../../../../../services/toast.service';

interface IProvisionState {
	loading: boolean;
	error: string | null;
	result: IProvisionOneSignalAppRes | null;
}

export const useProvisionOneSignalApp = () => {
	const [state, setState] = useState<IProvisionState>({
		loading: false,
		error: null,
		result: null,
	});

	const provision = async (communityId: string): Promise<IProvisionOneSignalAppRes | null> => {
		setState({ loading: true, error: null, result: null });

		try {
			const body: IProvisionOneSignalAppReq = { communityId };

			const res = await HttpWrapper.callUrl<IProvisionOneSignalAppReq, IProvisionOneSignalAppRes>(
				URLWrapper.urls.platformAdmin.oneSignal.provision,
				HttpMethod.POST,
				body,
				VProvisionOneSignalApp
			);

			setState({ loading: false, error: null, result: res });
			toastService.success('OneSignal app provisioned successfully!');
			return res;
		} catch (err: any) {
			const message: string = err?.message || 'Failed to provision OneSignal app.';
			setState({ loading: false, error: message, result: null });
			toastService.error(message);
			return null;
		}
	};

	const clearError = () => setState(s => ({ ...s, error: null }));

	return { ...state, provision, clearError };
};
